import React from "react";
import { ButtonStylized, ButtonStylizedType } from "@mental-mint/shared-ui";
import * as Lucide from "lucide-react";

/**
 * Props for the StartOverButton component.
 */
interface StartOverButtonProps {
  /** Callback function when start over is clicked */
  onStartOver: () => void;
  /** Optional additional styles */
  additionalStyles?: React.CSSProperties;
}

/**
 * Common "Start Over" button component for WordDrift game.
 * Can be used in both the main game page and post-game screen.
 */
export const StartOverButton: React.FC<StartOverButtonProps> = ({
  onStartOver,
  additionalStyles,
}) => {
  return (
    <ButtonStylized 
      buttonType={ButtonStylizedType.Primary}
      onClick={onStartOver}
      icon={<Lucide.RotateCcw size={24} strokeWidth={3} />}
      text="Restart"
      additionalStyles={{
        fontSize: "1.2rem",
        width: "200px",
        height: "70px",
        ...additionalStyles 
      }}
    />
  );
};

export default StartOverButton;
